import { UnitPreview } from "@twinkltech/curriculum-architect-domain-hooks";
import { IconCommunicationInformation, Text } from "@twinkltech/web-ui";
import { useId } from "react";

import { TagList } from "../TagList/TagList";
import { getCohortSlugTranslations } from "../TagList/utils/getCohortSlugTranslations/getCohortSlugTranslations";
import { getThreadSlugTranslations } from "../TagList/utils/getThreadSlugTranslations/getThreadSlugTranslations";

export const PreviewUnitContent = ({ unit }: { unit: UnitPreview }) => {
  const cardLabelId = useId();

  const tags = [
    ...getCohortSlugTranslations(unit?.keyStageSlug),
    ...getThreadSlugTranslations(unit?.threads || []),
  ];

  return (
    <div className="rounded-lg flex flex-col flex-grow gap-6">
      <div aria-labelledby={cardLabelId} className="flex gap-6" role="region">
        <div
          className="min-w-[100px] w-[100px] h-[100px] rounded bg-cover bg-center bg-neutral-100 border"
          role="presentation"
          style={{
            backgroundImage: `url(${unit?.keyArtUrl})`,
          }}
        />
        <div className="max-w-[800px] flex flex-col gap-2 justify-center">
          <Text
            as="h2"
            className="line-clamp-1"
            id={cardLabelId}
            variant="lg-medium"
          >
            {unit.title}
          </Text>
          <div className="flex gap-2" role="group">
            <TagList tags={new Set(tags)} variant="default" />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2" role="group">
          <Text as="h2" variant="lg-medium">
            Overview
          </Text>
          <Text as="p">{unit.description}</Text>
        </div>
        <div className="flex flex-col gap-2" role="group">
          <Text as="h2" variant="lg-medium">
            {`Learning Sequence (${unit?.resources?.length} lessons)`}
          </Text>
          <ol aria-label="Learning Sequence" className="pl-6 list-decimal">
            {unit?.resources?.length > 0 ? (
              unit?.resources?.map((item) => (
                <li key={item.resourceId}>
                  <Text as="p">{item.title}</Text>
                </li>
              ))
            ) : (
              <li>
                <Text as="p">No lessons added to this unit yet.</Text>
              </li>
            )}
          </ol>
        </div>
      </div>

      <div className="flex items-center gap-4 bg-neutral-100 p-200 rounded-2xl">
        <IconCommunicationInformation className="w-7" />
        <div>
          <Text as="p" className="m-0! leading-tight" variant="base-medium">
            Plan this unit to get links to all learning resources
          </Text>
        </div>
      </div>
    </div>
  );
};
